import { createSlice } from '@reduxjs/toolkit';
import {
  GET_LEAD_DETAIL,
  UPDATE_LEAD_DETAIL
} from 'redux/sagas/actions/leadDetail';

const initialState = {
  data: {},
  isLoading: false,
  isLoadingUpdate: false,
  updatingSection: ''
};

export const leadDetailSlice = createSlice({
  name: '@@leadDetail',
  initialState,
  reducers: {
    SHOW_SPINNER: state => ({
      ...state,
      isLoading: true
    }),
    HIDE_SPINNER: state => ({
      ...state,
      isLoading: false
    }),
    SET_SHOW_HISTORY_TAB: (state, action) => ({
      ...state,
      showHistoryTab: action.payload
    })
  },
  extraReducers: {
    [GET_LEAD_DETAIL._SUCCESS]: (state, action) => ({
      ...state,
      isLoading: false,
      data: action.payload
    }),
    [GET_LEAD_DETAIL._ERROR]: (state, action) => ({
      ...state,
      isLoading: false,
      data: {}
    }),
    [GET_LEAD_DETAIL._REQUEST]: (state, action) => ({
      ...state,
      isLoading: true,
      data: {}
    }),
    [UPDATE_LEAD_DETAIL._SUCCESS]: (state, action) => ({
      ...state,
      isLoadingUpdate: false,
      updatingSection: ''
    }),
    [UPDATE_LEAD_DETAIL._ERROR]: (state, action) => ({
      ...state,
      isLoadingUpdate: false,
      updatingSection: ''
    }),
    [UPDATE_LEAD_DETAIL._REQUEST]: (state, action) => ({
      ...state,
      isLoadingUpdate: true,
      updatingSection: action.payload?.dataSectionTitle
    })
  }
});

export const { SHOW_SPINNER, HIDE_SPINNER } = leadDetailSlice.actions;

export default leadDetailSlice.reducer;
